// extracted by mini-css-extract-plugin
export default {"layoutRoot":"dashboardLayout_layoutRoot__b-FYT","content":"dashboardLayout_content__kU560"};